'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.12.1';


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/lib/version.js